import type { CuratedTemplateCategoryKey } from './types/curated-template-category-key'
import type { TemplateCategorySelection } from './types/template-category-selection'

/** `/templates/categories` doesn't include these — added client-side. Order here is the order
 *  they appear in the combobox, ahead of the real fetched categories. */
export const CURATED_TEMPLATE_CATEGORY_OPTIONS: ReadonlyArray<{
  key: CuratedTemplateCategoryKey
  label: string
}> = [
  { key: 'all', label: 'All' },
  { key: 'custom', label: 'Custom Templates' },
]

const CURATED_PREFIX = 'curated:'
const CATEGORY_PREFIX = 'category:'

export function encodeTemplateCategorySelection(selection: TemplateCategorySelection): string {
  if (selection.type === 'curated') return `${CURATED_PREFIX}${selection.key}`
  return `${CATEGORY_PREFIX}${selection.categoryId}`
}

export function decodeTemplateCategorySelection(
  value: string | null
): TemplateCategorySelection | null {
  if (!value) return null

  if (value.startsWith(CURATED_PREFIX)) {
    const key = value.slice(CURATED_PREFIX.length) as CuratedTemplateCategoryKey

    if (CURATED_TEMPLATE_CATEGORY_OPTIONS.some((option) => option.key === key)) {
      return { type: 'curated', key }
    }

    return null
  }

  if (value.startsWith(CATEGORY_PREFIX)) {
    const categoryId = Number(value.slice(CATEGORY_PREFIX.length))

    if (!Number.isFinite(categoryId)) return null

    return { type: 'category', categoryId }
  }

  return null
}

export const DEFAULT_TEMPLATE_CATEGORY_VALUE = encodeTemplateCategorySelection({
  type: 'curated',
  key: 'custom',
})
